var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M2.65909091,28 C2.96590909,28 3.23863636,27.93 3.51136364,27.825 C14.4886364,23.24 22.9090909,15.96 23.25,15.68 C23.7272727,15.26 24,14.63 24,14 C24,13.37 23.7272727,12.74 23.25,12.355 C22.9090909,12.04 14.4886364,4.76 3.51136364,0.175 C3.23863636,0.07 2.93181818,0 2.65909091,0 C2.25,0 1.875,0.105 1.53409091,0.315 C0.954545455,0.7 0.545454545,1.33 0.511363636,2.03 C0.477272727,2.24 0,7.91 0,14 C0,20.09 0.477272727,25.76 0.511363636,26.005 C0.545454545,26.705 0.954545455,27.335 1.53409091,27.685 C1.875,27.895 2.28409091,28 2.65909091,28 Z"})));
}

Play.defaultProps = {"width":"24px","height":"28px","viewBox":"0 0 24 28","className":"play"};

module.exports = Play;

Play.default = Play;
